import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["timedRef"];
function LoadingIndicatorLinearComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("rebrand", ctx_r0.rebrand)("fluid", ctx_r0.fluid);
    i0.ɵɵattribute("aria-label", ctx_r0.label ? ctx_r0.label : null)("aria-busy", ctx_r0.isBusy)("aria-valuenow", ctx_r0.progress);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r0.progress + "%");
  }
}
function LoadingIndicatorLinearComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "div", null, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("rebrand", ctx_r0.rebrand)("fluid", ctx_r0.fluid);
    i0.ɵɵattribute("aria-label", ctx_r0.label ? ctx_r0.label : null)("aria-busy", ctx_r0.isBusy);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("transition-duration", ctx_r0.duration);
  }
}
function LoadingIndicatorLinearComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "div", 7)(2, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("rebrand", ctx_r0.rebrand)("fluid", ctx_r0.fluid);
    i0.ɵɵattribute("aria-label", ctx_r0.label ? ctx_r0.label : null)("aria-busy", ctx_r0.isBusy);
  }
}
let LoadingIndicatorLinearComponent = /*#__PURE__*/(() => {
  class LoadingIndicatorLinearComponent {
    constructor() {
      this.type = 'indeterminate';
      this.label = '';
      this.fluid = false;
      this.rebrand = false;
      this.isBusy = true;
    }
    // use 'set' on viewchild becaus it's inside a ngIf in template
    set content(content) {
      if (content) {
        this.timedProgressElem = content;
      }
    }
    ngAfterViewInit() {
      // start animating "timed mode" mode on load
      if (this.type === 'timed' && this.duration && this.timedProgressElem) {
        // let a tick go by so the browser sees the difference:
        setTimeout(() => {
          this.timedProgressElem.nativeElement.style.width = '100%';
          // set isBusy to false after transition ends:
          this.timedProgressElem.nativeElement.addEventListener('transitionend', () => {
            this.isBusy = false;
          });
        }, 0); // end:setTimeout
      }
    }
    ngOnChanges(changes) {
      if (changes?.progress?.currentValue === 100) {
        this.isBusy = false;
      } else {
        this.isBusy = true;
      }
    }
  }
  LoadingIndicatorLinearComponent.ɵfac = function LoadingIndicatorLinearComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoadingIndicatorLinearComponent)();
  };
  LoadingIndicatorLinearComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LoadingIndicatorLinearComponent,
    selectors: [["stb-loading-indicator-linear"]],
    viewQuery: function LoadingIndicatorLinearComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
      }
    },
    inputs: {
      type: "type",
      label: "label",
      progress: "progress",
      duration: "duration",
      fluid: "fluid",
      rebrand: "rebrand"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 3,
    consts: [["timedRef", ""], ["class", "stb-loading-indicator-linear", "role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 3, "rebrand", "fluid", 4, "ngIf"], ["class", "stb-loading-indicator-linear", "role", "progressbar", 3, "rebrand", "fluid", 4, "ngIf"], ["class", "material-indeterminate-container", "role", "progressbar", 3, "rebrand", "fluid", 4, "ngIf"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "stb-loading-indicator-linear"], ["role", "progressbar", 1, "stb-loading-indicator-linear"], ["role", "progressbar", 1, "material-indeterminate-container"], [1, "mat-progress-bar-primary", "mat-progress-bar-fill", "mat-progress-bar-element"], [1, "mat-progress-bar-secondary", "mat-progress-bar-fill", "mat-progress-bar-element"]],
    template: function LoadingIndicatorLinearComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, LoadingIndicatorLinearComponent_div_0_Template, 2, 9, "div", 1)(1, LoadingIndicatorLinearComponent_div_1_Template, 3, 8, "div", 2)(2, LoadingIndicatorLinearComponent_div_2_Template, 3, 6, "div", 3);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.type === "progress");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.type === "timed");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.type === "indeterminate");
      }
    },
    dependencies: [i1.NgIf],
    styles: ["[_nghost-%COMP%]   .rebrand[_ngcontent-%COMP%]{--progressbar-height-lg: .375rem;--progressbar-height-sm: .25rem;--progressbar-border-radius: 2px;background-color:var(--p-color-static-grey-background, var(--p-color-grey-200));border-radius:var(--progressbar-border-radius);height:var(--progressbar-height-sm)}[_nghost-%COMP%]   .rebrand[_ngcontent-%COMP%]   .mat-progress-bar-fill[_ngcontent-%COMP%]:after{background-color:var(--p-color-static-red-foreground, var(--p-color-red-600));border-radius:var(--progressbar-border-radius)}[_nghost-%COMP%]   .rebrand.stb-loading-indicator-linear[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{border-radius:var(--progressbar-border-radius);height:var(--progressbar-height-sm)}[_nghost-%COMP%]   .rebrand.fluid[_ngcontent-%COMP%]{max-width:var(--progress-bar-max-width, 600px);width:100%}@media (min-width: 600px){[_nghost-%COMP%]   .rebrand[_ngcontent-%COMP%]{height:var(--progressbar-height-lg)}[_nghost-%COMP%]   .rebrand.stb-loading-indicator-linear[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{height:var(--progressbar-height-lg)}}.stb-loading-indicator-linear[_ngcontent-%COMP%]{width:288px;height:4px;background-color:#19191929;padding:0;border-radius:2px}.stb-loading-indicator-linear[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{height:4px;border-radius:2px;transition:width .4s ease-in;width:0%;background-color:#bf0900}.material-indeterminate-container[_ngcontent-%COMP%]{width:288px;height:4px;position:relative;display:block;overflow:hidden;background-color:#19191929;border-radius:2px}.mat-progress-bar-element[_ngcontent-%COMP%], .mat-progress-bar-fill[_ngcontent-%COMP%]:after{height:100%;position:absolute;width:100%}.mat-progress-bar-fill[_ngcontent-%COMP%]:after{animation:none;content:\"\";display:inline-block;left:0;border-radius:2px;background-color:#bf0900}.mat-progress-bar-fill[_ngcontent-%COMP%]{transition:none}.mat-progress-bar-primary[_ngcontent-%COMP%]{backface-visibility:hidden;animation:_ngcontent-%COMP%_mat-progress-bar-primary-indeterminate-translate 2s infinite linear;left:-145.166611%}.mat-progress-bar-primary.mat-progress-bar-fill[_ngcontent-%COMP%]:after{backface-visibility:hidden;animation:_ngcontent-%COMP%_mat-progress-bar-primary-indeterminate-scale 2s infinite linear}.mat-progress-bar-secondary[_ngcontent-%COMP%]{backface-visibility:hidden;animation:_ngcontent-%COMP%_mat-progress-bar-secondary-indeterminate-translate 2s infinite linear;left:-54.888891%;display:block}.mat-progress-bar-secondary.mat-progress-bar-fill[_ngcontent-%COMP%]:after{backface-visibility:hidden;animation:_ngcontent-%COMP%_mat-progress-bar-secondary-indeterminate-scale 2s infinite linear}@keyframes _ngcontent-%COMP%_mat-progress-bar-primary-indeterminate-translate{0%{transform:translate(0)}20%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(0)}59.15%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(83.67142%)}to{transform:translate(200.611057%)}}@keyframes _ngcontent-%COMP%_mat-progress-bar-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.334731,.12482,.785844,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.661479)}to{transform:scaleX(.08)}}@keyframes _ngcontent-%COMP%_mat-progress-bar-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.515058,.409685);transform:translate(0)}25%{animation-timing-function:cubic-bezier(.31033,.284058,.8,.733712);transform:translate(37.651913%)}48.35%{animation-timing-function:cubic-bezier(.4,.627035,.6,.902026);transform:translate(84.386165%)}to{transform:translate(160.277782%)}}@keyframes _ngcontent-%COMP%_mat-progress-bar-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.15,0,.515058,.409685);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.31033,.284058,.8,.733712);transform:scaleX(.457104)}44.15%{animation-timing-function:cubic-bezier(.4,.627035,.6,.902026);transform:scaleX(.72796)}to{transform:scaleX(.08)}}"]
  });
  return LoadingIndicatorLinearComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingIndicatorLinearModule = /*#__PURE__*/(() => {
  class LoadingIndicatorLinearModule {}
  LoadingIndicatorLinearModule.ɵfac = function LoadingIndicatorLinearModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoadingIndicatorLinearModule)();
  };
  LoadingIndicatorLinearModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: LoadingIndicatorLinearModule
  });
  LoadingIndicatorLinearModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return LoadingIndicatorLinearModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of loading-indicator
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingIndicatorLinearComponent, LoadingIndicatorLinearModule };
